import { render, staticRenderFns } from "./VideoDetailsContainer.vue?vue&type=template&id=e6f2b2e8&scoped=true"
import script from "./VideoDetailsContainer.vue?vue&type=script&lang=js"
export * from "./VideoDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./VideoDetailsContainer.vue?vue&type=style&index=0&id=e6f2b2e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f2b2e8",
  null
  
)

export default component.exports